module.exports = __webpack_public_path__ + "static/media/sanyogg.06cc4ff6.png";